import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TokenDisplayComponent} from './token-display.component';

const routes: Routes = [
    {path: 'tokendisplay', component: TokenDisplayComponent},
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-display/token-display.routing.ts